import { enGB } from 'date-fns/locale/en-GB';

/**
 * date-fns locale whose short date is DD/MM/YYYY.
 * Week starts on Monday.
 */
export const datePickerAdapterLocale = enGB;

/** Empty field mask. Month pickers pass their own format, for example MM-yyyy. */
export const DATE_PICKER_FORMAT = 'dd/MM/yyyy';
